import { Component, OnDestroy, OnInit } from "@angular/core";
import { DialogContentBase, DialogRef } from "@progress/kendo-angular-dialog";
import { AttachmentService } from "app/intake/attachments/attachment.service";
import { CedNotificationService } from "ced-ng-library";
import { Console } from "console";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";


@Component({
    selector: 'app-correspondance-attachments',
    templateUrl: './correspondance-attachments.component.html'
})
export class CorrespondanceAttachemntsComponent extends DialogContentBase implements OnInit, OnDestroy {

    dossierId: string;
    private _subject$: Subject<boolean> = new Subject();
    dataSource:any[]=[];


    constructor(dialog: DialogRef,
        private attachmentService: AttachmentService,
        private cedNotificationService: CedNotificationService
    ) {
        super(dialog);
    }

    cancel() {
        this.dialog.close();
    }

    ngOnDestroy(): void {
        this._subject$.next();
        this._subject$.complete();
    }

    ngOnInit(): void {
        this.attachmentService
            .getByDossierId(this.dossierId)
            .pipe(takeUntil(this._subject$))
            .subscribe((data: any) => {
                this.dataSource = [...data];
            },
            (error) => {
              this.cedNotificationService.error("NOTIFICATIONS.GET_DOSSIER");
            });
    }
}